<template>
  <div :class="{'cs-courseEnrollmentDetail-mainContainer': true, 'cs-courseEnrollmentDetail-mainContainer-vertical': isVerticalAlign}">
    <el-row :class="{'cs-courseEnrollmentDetail-container': true, 'cs-courseEnrollmentDetail-container-vertical': isVerticalAlign}">
      <el-col :span="isVerticalAlign ? 24 : 20" class="cs-courseEnrollmentDetail-left">
        <el-row>
          <el-col :span="isVerticalAlign ? 24 : 12" class="cs-courseEnrollmentDetail-innerLeft">
            <el-row>
              <el-col :span="innerColWidthLeft">
                业务:
              </el-col>
              <el-col :span="innerColWidthRight" v-if="dataIn.courseData.courseType == 1">
                {{dataIn.courseData.courseTypeText}}
              </el-col>
              <el-col :span="innerColWidthRight"
                v-if="dataIn.courseData.courseType == 2 || dataIn.courseData.courseType == 3 || dataIn.courseData.courseType == 4">
                {{dataIn.courseData.categoryText}}
              </el-col>
            </el-row>
            <el-row v-if="dataIn.courseData.courseType == 1">
              <el-col :span="innerColWidthLeft">
                学校:
              </el-col>
              <el-col :span="innerColWidthRight">
                {{dataIn.courseData.universityGroupText}}
              </el-col>
            </el-row>
            <el-row v-if="dataIn.courseData.courseType == 1 || dataIn.courseData.courseType == 3">
              <el-col :span="innerColWidthLeft">
                学期:
              </el-col>
              <el-col :span="innerColWidthRight">
                {{dataIn.courseData.termText}}
              </el-col>
            </el-row>
            <el-row v-if="dataIn.courseData.courseType == 2 || dataIn.courseData.courseType == 3 || dataIn.courseData.courseType == 4">
              <el-col :span="innerColWidthLeft">
                校区:
              </el-col>
              <el-col :span="innerColWidthRight">
                {{dataIn.courseData.campusText}}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="innerColWidthLeft">
                课程:
              </el-col>
              <el-col :span="innerColWidthRight">
                {{dataIn.courseData.courseName}}
              </el-col>
            </el-row>
            <el-row v-if="!!dataIn.courseData.changeFromCourseName" class="cs-redLabel">
              <el-col :span="innerColWidthLeft">
                换课:
              </el-col>
              <el-col :span="innerColWidthRight">
                {{dataIn.courseData.changeFromCourseName}}
              </el-col>
            </el-row>
            <el-row v-if="dataIn.courseData.courseType == 1 || dataIn.courseData.courseType == 2">
              <el-col :span="innerColWidthLeft">
                类型:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getCourseCategoryText()}}</span>
                  <span v-if="hasFreeTrial && form.isFreeTrial">(试听课)</span>
                </div>
                <div v-else>
                  <el-select size="small" v-model="form.categoryId" placeholder="请选择类型" @change="onCategoryChange">
                    <el-option v-for="item in dataIn.courseCategoryList" :key="item.Id" :label="item.Label" :value="item.Id">
                    </el-option>
                  </el-select>
                  <el-checkbox v-if="hasFreeTrial" v-model="form.isFreeTrial" @change="onIsFreeTrialChange">是否试听课</el-checkbox>
                </div>
                <!-- <div v-show="isNormalClass">
                  <div v-if="isReadonly">
                    <span>{{getIsVideoFreeText()}}</span>
                  </div>
                  <div v-else>
                    <el-checkbox v-model="form.isVideoFree" @change="onModelChange">是否视频课</el-checkbox>
                  </div>
                </div> -->
              </el-col>
            </el-row>
            <el-row v-if="dataIn.courseData.courseType == 3">
              <el-col :span="innerColWidthLeft">
                类型:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>全部视频免费</span>
                </div>
                <div v-else>
                  <el-checkbox v-model="form.isVideoFree">全部视频免费</el-checkbox>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="!isNormalClass && !form.isFreeTrial && !isReviewCourse">
              <el-col :span="innerColWidthLeft">
                费用类型:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span v-if="isVip && form.vipCoursePriceId">{{getVipCoursePriceDescription()}}</span>
                  <span v-else>{{getCourseCategoryOptionText()}}</span>
                </div>
                <div v-else>
                  <el-select v-if="isVip" size="small" v-model="form.vipCoursePriceId" placeholder="请选择费用类型" @change="onVipCoursePriceChange">
                    <el-option v-for="item in dataIn.vipCoursePrices" :key="item.Id" :label="item.Description" :value="item.Id">
                    </el-option>
                  </el-select>
                  <el-select v-else size="small" v-model="form.categoryOptionId" placeholder="请选择费用类型" @change="onCategoryOptionChange">
                    <el-option v-for="item in categoryOptionList" :key="item.Id" :label="item.Label" :value="item.Id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="form.isFreeTrial">
              <el-col :span="innerColWidthLeft">
                课节:
              </el-col>
              <el-col :span="15">
                <div v-if="isReadonly">
                  <div>
                    <span class="cs-reviewCourseActivation">{{getCourseActivationText(form.freeTrialCourseActivationId)}}</span>
                  </div>
                </div>
                <div v-else>
                  <el-select :loading="isLoadingCourseActivationList" size="small"
                    v-model="form.freeTrialCourseActivationId" placeholder="请选择课节" @change="onFreeTrialCourseActivationChange">
                    <el-option v-for="item in freeTrialCourseActivationList" :key="item.Id" :label="item.Name" :value="item.Id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isReviewCourse">
              <el-col :span="innerColWidthLeft">
                复习课起始:
              </el-col>
              <el-col :span="15">
                <div v-if="isReadonly">
                  <div>
                    <span>{{form.reviewCourseStart}}</span>至
                    <span>{{form.reviewCourseEnd}}</span>
                  </div>
                </div>
                <div v-else>
                  <el-date-picker class="cs-reviewCourse-date" v-model="reviewCourseDate" type="daterange" @change='onReviewCourseDateChange'
                    align="center" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    size="medium" :clearable="false"></el-date-picker>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isVip">
              <el-col :span="innerColWidthLeft">
                备注名:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{form.courseAlias}}</span>
                </div>
                <div v-else>
                  <el-autocomplete size="small" placeholder="请输入备注名" v-model="form.courseAlias" :fetch-suggestions="courseAliasQuerySearch"
                    class="input-width" />
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isHourPrice || dataIn.courseData.isHourPrice || isVip">
              <el-col :span="innerColWidthLeft">
                时长:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{form.courseCount}}小时</span>
                  <span>{{form.courseMinutes}}分钟</span>
                </div>
                <div v-else>
                  <div class="cs-courseEnrollmentDetail-number-container">
                    <el-input-number size="mini" v-model="form.courseCount" @change="onCourseCountChange" :step="hourStep" :min="0" :max="100"
                      label="小时数"></el-input-number> 小时
                  </div>
                  <div class="cs-courseEnrollmentDetail-number-container">
                    <el-input-number size="mini" v-model="form.courseMinutes" @change="onCourseMinutesChange" :step="1" :min="0" :max="60"
                      label="分钟数"></el-input-number> 分钟
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isNormalClass">
              <el-col :span="innerColWidthLeft">
                费用类型:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getPriceTypeText()}}</span>
                </div>
                <div v-else>
                  <el-checkbox v-if="dataIn.courseData.courseType != 2 && dataIn.courseData.courseType != 4" :disabled="!dataIn.hasAdvanceEnrollmentPrice"
                    v-model="form.isAdvanceEnrollmentPrice" @change="onIsAdvanceEnrollmentPriceChange">是否占位价</el-checkbox>
                  <el-select v-if="dataIn.courseData.courseType == 1" size="small" placeholder="选择占位"
                    :disabled="!form.isAdvanceEnrollmentPrice || isAdvanceEnrollmentDisabled" v-model="form.selectedStudentAdvanceEnrollmentId"
                    @change="onSelectedStudentAdvanceEnrollmentIdChange()">

                    <el-option :value="0" :label="'选择占位'">
                      选择占位
                    </el-option>
                    <el-option v-for="ae in studentAdvanceEnrollmentListInCourse" :label="'定金: '+ae.Amount + '$ | 折扣: ' +ae.Discount+' % ' + ae.Comment"
                      :key="ae.Key" :value="ae.Id">
                      定金: {{ae.Amount}} $ | 折扣: {{ae.Discount}} % {{ae.Comment}}
                    </el-option>
                  </el-select>

                  <el-checkbox :disabled="!dataIn.hasInternalPrice" v-model="form.isInternalPrice" @change="onIsInternalPriceChange">是否内部价</el-checkbox>

                  <el-checkbox :disabled="!dataIn.hasOriginalPrice" v-model="form.isOriginalPrice" @change="onIsOriginalPriceChange">是否原价</el-checkbox>

                  <span v-if="!dataIn.hasAdvanceEnrollmentPrice && !dataIn.hasInternalPrice"></span>

                </div>
              </el-col>
            </el-row>
            <el-row v-show="isNormalClass" v-if="dataIn.courseData.courseType == 1">
              <el-col :span="innerColWidthLeft">
                原价:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span :loading="isCalculating" class="cs-courseEnrollmentDetail-price">{{financialModel.price | toCurrency}}</span>
              </el-col>
            </el-row>
            <el-row v-show="isNormalClass" v-if="dataIn.courseData.courseType == 1 && (!isReadonly || (isReadonly && financialModel.weekPrice >0))">
              <el-col :span="innerColWidthLeft">
                当周价钱:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span :loading="isCalculating" class="cs-courseEnrollmentDetail-price">{{financialModel.weekPrice | toCurrency}}</span>
                <span :v-if="!isCalculating" class="cs-courseEnrollmentDetail-price">({{(financialModel.weekPrice - financialModel.price) | toCurrency}})</span>
              </el-col>
            </el-row>
            <el-row v-show="isNormalClass" v-if="dataIn.courseData.courseType == 1 && dataIn.courseData.isYearCourse">
              <el-col :span="innerColWidthLeft">
                年课学期:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getYearCourseTypeText()}}</span>
                </div>
                <div v-else>
                  <el-select size="small" v-model="form.yearCourseType" placeholder="请选择年课学期" @change="onYearCourseTypeChange">
                    <el-option v-for="item in yearCourseTypeList" :key="item.Value" :label="item.Text" :value="item.Value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isNormalClass" v-if="dataIn.courseData.courseType == 1">
              <el-col :span="innerColWidthLeft">
                开始周期:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getWeekText()}}</span>
                </div>
                <div v-else>
                  <el-select v-if="dataIn.courseData.isYearCourse" size="small" v-model="form.startWeek" placeholder="请选择开始周期" @change="onStartWeekChange">
                    <el-option v-for="item in yearCourseWeekList" :key="item.Week" :label="item.Label" :value="item.Week">
                    </el-option>
                  </el-select>
                  <el-select v-else size="small" v-model="form.startWeek" placeholder="请选择开始周期" @change="onStartWeekChange">
                    <el-option v-for="item in dataIn.weekList" :key="item.Week" :label="item.Label" :value="item.Week">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isNormalClass && !isOnlineCourse" v-if="dataIn.courseData.courseType == 1">
              <el-col :span="innerColWidthLeft">
                视频机制:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getSupplementVideoTypeText()}}</span>
                </div>
                <div v-else>
                  <el-radio-group size="small" v-model="form.supplementVideoType" @change="onSupplementVideoTypeChange">
                    <el-radio v-for="item in dataIn.supplementVideoTypeList" :key="item.Key" :label="item.Key">{{item.Value}}
                    </el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="dataIn.courseData.courseType == 1 && isOnlineCourse">
              <el-col :span="innerColWidthLeft">
                视频机制:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getSupplementVideoTypeText()}}</span>
                </div>
                <div v-else>
                  <el-checkbox v-model="isOnlineCourseVideoFree" @change="onOnlineCourseVideoFreeChange">可以观看报名节点前视频</el-checkbox>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isNormalClass" v-if="dataIn.courseData.courseType == 1">
              <el-col :span="innerColWidthLeft">
                AI课程:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getIsAiCourseEnabledText()}}</span>
                </div>
                <div v-else>
                  <el-checkbox v-model="form.isAiCourseEnabled">启用AI课程</el-checkbox>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isNormalClass" v-if="dataIn.courseData.courseType == 1">
              <el-col :span="innerColWidthLeft">
                保A课程:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getIsEnsureACourseText()}}</span>
                </div>
                <div v-else>
                  <el-checkbox v-model="form.isEnsureACourse">保A课程</el-checkbox>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="isVerticalAlign ? 24 : 12" class="cs-courseEnrollmentDetail-innerRight">
            <el-row v-show="isNormalClass || isReviewCourse">
              <el-col :span="innerColWidthLeft">
                签约合同:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getContractText()}}</span>
                  <!-- 这里不需要确认合同了(隐藏掉) -->
                  <!-- <el-link v-if="__findContractFiles(form.contractId).length > 0" v-loading="downloadLoading" type="primary" :underline="false" @click="downloadContractFile(form.contractId)">{{getContractText()}}</el-link> -->
                  <!-- <span style="float: right;">
                    <el-tooltip placement="top" :content="form.hasContractAgreed ? '已确认' : '未确认'">
                      <el-checkbox v-model="form.hasContractAgreed" :disabled="form.hasContractAgreed" @change="onHasContractAgreedChange" />
                    </el-tooltip>
                  </span> -->
                </div>
                <div v-else>
                  <el-select size="small" v-model="form.contractId" placeholder="请选择合同" @change="onContractChange">
                    <el-option :key="0" label="未签约" :value="0"></el-option>
                    <el-option v-for="item in contractList" :key="item.Id" :label="item.Description" :value="item.Id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="innerColWidthLeft">
                微信群:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{getWeChatGroupTypeText()}}</span>
                </div>
                <div v-else>
                  <el-select
                    size="small"
                    v-model="form.weChatGroupType"
                    placeholder="请选择微信群"
                  >
                    <el-option
                      v-for="item in dataIn.weChatGroupTypeList"
                      :key="item.Key"
                      :label="item.Value"
                      :value="item.Key"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row> -->
            <!-- <el-row v-if="dataIn.courseData.courseType == 1">
              <el-col :span="innerColWidthLeft">
                保分:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span>{{courseAssureScore}}</span>
              </el-col>
            </el-row> -->

            <!-- 已废弃_20220111
            <el-row>
              <el-col :span="innerColWidthLeft">
                可用积分:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span>{{availableBonusPoint}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="innerColWidthLeft">
                使用积分：
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{financialModel.bonusPointCost}}</span>
                </div>
                <div v-else>
                  <el-input
                    placeholder="请输入积分"
                    v-model="financialModel.bonusPointCost"
                    size="small"
                    @change="onBonusPointCostChange"
                    :disabled="bonusPointDisabled || (totalBonusPoint == 0 && financialModel.bonusPointCost == 0)"
                  ></el-input>
                  <span v-if="bonusPointDisabled">非会员无法使用积分</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="innerColWidthLeft">
                使用现金减：
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{financialModel.cashDecreasedAmount}}</span>
                </div>
                <div v-else>
                  <el-input
                    placeholder="请输入现金减"
                    v-model="financialModel.cashDecreasedAmount"
                    size="small"
                    @change="onCashDecreasedAmountChange"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
            -->

            <el-row v-show="!form.isFreeTrial">
              <el-col :span="innerColWidthLeft">
                使用优惠劵：
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>
                    {{financialModel.couponCode}}
                    <span v-if="financialModel.couponDiscountDollar > 0"> 抵扣：{{financialModel.couponDiscountDollar}}</span>
                  </span>
                </div>
                <div v-else>
                  <el-input placeholder="请输入优惠码" v-model="financialModel.couponCode" size="small"></el-input>
                  <div class="couponCodeExtra">
                    <el-button type="primary" size="mini" @click="onCouponCodeClick">验证</el-button>
                    <el-button type="primary" size="mini" @click="onCouponRevertClick" v-if="financialModel.couponDiscountDollar > 0">撤销</el-button>
                    <span v-if="financialModel.couponDiscountDollar"> 抵扣：{{financialModel.couponDiscountDollar}}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="isVip">
              <el-col :span="innerColWidthLeft">
                课单价:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span class="cs-courseEnrollmentDetail-price">{{vipUnitPrice | toCurrency}} / 小时</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="innerColWidthLeft">
                优惠政策价格:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span :loading="isCalculating" class="cs-courseEnrollmentDetail-price">{{financialModel.discountPrice | toCurrency}}</span>
                <span :v-if="!isCalculating"
                  class="cs-courseEnrollmentDetail-price">({{(financialModel.discountPrice - financialModel.weekPrice) | toCurrency}})</span>
              </el-col>
            </el-row>
            <el-row class="cs-courseEnrollmentDetail-reduceprice" v-if="!form.isFreeTrial && financialModel.bonusPointAmount > 0">
              <el-col :span="innerColWidthLeft">
                积分抵扣:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span>-{{financialModel.bonusPointCost}}({{financialModel.bonusPointAmount | toCurrency}})</span>
              </el-col>
            </el-row>
            <el-row class="cs-courseEnrollmentDetail-reduceprice" v-if="!form.isFreeTrial && financialModel.cashDecreasedAmount > 0">
              <el-col :span="innerColWidthLeft">
                现金减抵扣:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span>-{{financialModel.cashDecreasedAmount | toCurrency}}</span>
              </el-col>
            </el-row>
            <el-row v-if="!form.isFreeTrial && !!wComment && !USERMANAGER.isStudent">
              <el-col :span="innerColWidthLeft">
                积分&现金减备注:
              </el-col>
              <el-col :span="innerColWidthRight">
                <pre>{{wComment}}</pre>
              </el-col>
            </el-row>
            <el-row class="cs-courseEnrollmentDetail-reduceprice" v-if="financialModel.couponDiscountDollar > 0">
              <el-col :span="innerColWidthLeft">
                优惠劵抵扣:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span>-{{financialModel.couponDiscountDollar | toCurrency}}</span>
              </el-col>
            </el-row>
            <el-row v-if="!!financialModel.changeCourseDifferentPrice">
              <el-col :span="innerColWidthLeft">
                换课差价:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span class="cs-courseEnrollmentDetail-price">{{financialModel.changeCourseDifferentPrice | toCurrency}}</span>
              </el-col>
            </el-row>
            <el-row v-if="!!financialModel.changeCourseDifferentPrice || !!financialModel.changeCourseRefundBalance">
              <el-col :span="innerColWidthLeft">
                退余额:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span class="cs-courseEnrollmentDetail-price">{{financialModel.changeCourseRefundBalance | toCurrency}}</span>
              </el-col>
            </el-row>
            <el-row v-show="!isVip">
              <el-col :span="innerColWidthLeft">
                备注:
              </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{form.comment}}</span>
                </div>
                <div v-else>
                  <el-input placeholder="请输入备注信息" type="textarea" rows="3" v-model="form.comment" class="input-width"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="isVerticalAlign">
              <el-col :span="innerColWidthLeft">
                最终价格:
              </el-col>
              <el-col :span="innerColWidthRight">
                <span :loading="isCalculating">C{{financialModel.subtotal | toCurrency}}</span>
                <span v-if="dataIn.courseData.isRefund" class="cs-redLabel">已退款</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col v-if="!isVerticalAlign" :span="4" class="cs-courseEnrollmentDetail-right">
        <div class="cs-courseEnrollmentDetail-rightInner">
          <span>最终价格</span>
          <span :loading="isCalculating">C{{financialModel.subtotal | toCurrency}}</span>
          <span v-if="dataIn.courseData.isRefund" class="cs-redLabel">已退款</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-courseEnrollmentDetail-mainContainer {
  margin-top: 20px;
  background-color: #f5f7fa;

  &.cs-courseEnrollmentDetail-mainContainer-vertical {
    margin-top: 0;
    height: 100%;
  }

  .cs-courseEnrollmentDetail-container {
    display: flex;
    flex-direction: row;

    .cs-courseEnrollmentDetail-left {
      padding: 20px;

      .cs-reviewCourseActivation {
        display: block;
      }

      .cs-courseEnrollmentDetail-innerLeft {
        border-right: 1px solid #ced3d9;
      }

      .cs-courseEnrollmentDetail-innerRight {
        padding-left: 20px;

        .couponCodeExtra {
          margin-top: 5px;
        }
      }

      .el-row {
        margin-top: 5px;

        &:first-of-type {
          margin-top: 0;
        }

        .el-col {
          vertical-align: middle;

          .el-checkbox {
            display: block;
            margin-left: 0;
          }

          .cs-courseEnrollmentDetail-number-container{
            display: inline-block;
            margin-top: 5px;

            /deep/ .el-input-number--mini{
              width: 100px;
            }
            
            &:first-of-type{
                margin-top: 0;
              }
          }
          
        }
      }
    }

    .cs-courseEnrollmentDetail-right {
      padding: 20px;
      background-color: #e1edf7;
      display: flex;
      align-items: center;

      .cs-courseEnrollmentDetail-rightInner {
        display: block;
        margin: auto;
        span {
          display: block;
        }
      }
    }

    .cs-courseEnrollmentDetail-price {
      color: grey;
    }

    .cs-courseEnrollmentDetail-reduceprice {
      color: red;
    }

    .el-radio {
      display: block;
    }

    &.cs-courseEnrollmentDetail-container-vertical {
      .cs-courseEnrollmentDetail-left {
        .cs-courseEnrollmentDetail-innerLeft {
          border-right: none;
        }

        .cs-courseEnrollmentDetail-innerRight {
          padding-left: 0;
        }
      }
    }
  }

  .cs-reviewCourse-date{
    width: 220px;

    /deep/ .el-range-separator{
      width: 20px;
    }

    /deep/ .el-range__close-icon{
      display: none;
    }
  }
}
</style>

<script>
import { getYearCourseType, downloadFile, formatDate } from "../../../config/mUtils";
import {
  getBlobFileUrlById,
  downloadFileToBlob,
} from "@/service/blobStorage.service";
import {
  validateCoupon,
  agreeEFWCourseContracts,
} from "../../../service/enrollmentFee.service";
import {
  getYearCourseTypeWithWeek,
  getCourseAssureScore,
} from "../../../service/speedupCourse.service";
import { getReviewCourseActivations, getCourseActivations } from "../../../service/common.service";

export default {
  props: {
    studentId: Number,
    vipCourseAliasList: Array,
    isReadonly: Boolean,
    bonusPointDisabled: Boolean,
    isCalculating: Boolean,
    totalBonusPoint: Number,
    availableBonusPoint: Number,
    priceSettings: Object,
    allContractList: Object,
    wComment: String,
    isVerticalAlign: Boolean,
    dataIn: {
      vipCoursePrices: Array,
      weekList: Array,
      supplementVideoTypeList: Array,
      contractList: Array,
      weChatGroupTypeList: Array,
      selectedDiscountList: Array,
      courseCategoryList: Array,
      hasAdvanceEnrollmentPrice: Boolean,
      hasInternalPrice: Boolean,
      hasOriginalPrice: Boolean,
      modelData: {
        isAdvanceEnrollmentPrice: Boolean,
        isInternalPrice: Boolean,
        isOriginalPrice: Boolean,
        isFreeTrial: Boolean,
        isVideoFree: Boolean,
        isAiCourseEnabled: Boolean,
        isEnsureACourse: Boolean,
        startWeek: Number,
        categoryId: Number,
        categoryOptionId: Number,
        vipCoursePriceId: Number,
        courseCount: Number,
        courseMinutes: Number,
        supplementVideoType: Number,
        supplementVideoCount: Number,
        contractId: Number,
        weChatGroupType: Number,
        cashDecreased: Number,
        comment: String,
        selectedStudentAdvanceEnrollmentId: Number,
        yearCourseType: Number,
        courseActivationIdList: Array,
        freeTrialCourseActivationId: Number,
        courseAlias: String,
        reviewCourseStart: String,
        reviewCourseEnd: String
      },
      priceData: {
        price: Number,
        discountPrice: Number,
        subtotal: Number,
        supplementVideoPrice: Number,
        bonusPointCost: Number,
        bonusPointAmount: Number,
        cashDecreasedAmount: Number,
        oldBonusPointCost: Number,
        couponCode: String,
        couponDiscountDollar: Number,
        couponDiscountPrice: Number,
      },
      courseData: {
        courseId: Number,
        courseName: String,
        courseType: Number,
        courseTypeText: String,
        universityGroup: Number,
        universityGroupText: String,
        termId: Number,
        termText: String,
        isRefund: Boolean,
        categoryId: Number,
        categoryText: String,
        campusId: Number,
        campusText: String,
        isHourPrice: Boolean,
        isYearCourse: Boolean,
        studentAdvanceEnrollmentList: Array,
        studentAdvanceEnrollmentAdditional: String,
      },
    },
  },
  data() {
    return {
      downloadLoading: false,
      innerColWidthLeft: 7,
      innerColWidthRight: 13,
      innerColWidthThird: 4,
      form: {
        id: 0,
        isAdvanceEnrollmentPrice: false,
        isInternalPrice: false,
        isOriginalPrice: false,
        isFreeTrial: false,
        isVideoFree: false,
        isAiCourseEnabled: false,
        isEnsureACourse: false,
        startWeek: 1,
        categoryId: 0,
        categoryOptionId: 0,
        vipCoursePriceId: null,
        courseCount: 1,
        courseMinutes: 0,
        supplementVideoType: 0,
        contractId: 0,
        hasContractAgreed: false,
        weChatGroupType: 0,
        comment: "",
        selectedStudentAdvanceEnrollmentId: 0,
        yearCourseType: 0,
        courseActivationIdList: [],
        freeTrialCourseActivationId: "",
        courseAlias: "",
        reviewCourseStart: null,
        reviewCourseEnd: null
      },
      financialModel: {
        price: 0,
        weekPrice: 0,
        discountPrice: 0,
        subtotal: 0,
        supplementVideoPrice: 0,
        bonusPointCost: 0,
        bonusPointAmount: 0,
        cashDecreasedAmount: 0,
        oldBonusPointCost: 0,
        couponCode: "",
        couponDiscountDollar: 0,
      },
      categoryOptionList: [],
      isNormalClass: true,
      isVip: false,
      isHourPrice: false,
      hasFreeTrial: false,
      hourStep: 1,
      preStudentAdvanceEnrollmentId: 0,
      isAdvanceEnrollmentDisabled: false,
      bonusPointToMoney_Money: 0,
      bonusPointToMoney_BonusPoint: 0,
      currentWeek: 1,
      yearCourseTypeAllList: [],
      yearCourseTypeList: [],
      yearCourseWeekList: [],
      yearCourseTypeWithWeek: {},
      courseAssureScore: "",
      contractList: [],

      isReviewCourse: false, //是否复习课
      isLoadingCourseActivationList: false,
      isRetrieveCourseActivation: false,
      courseActivationListAll: [],
      reviewCourseActivationList: [],
      freeTrialCourseActivationList: [],

      isOnlineCourse: false,
      isOnlineCourseVideoFree: false,

      studentAdvanceEnrollmentAdditionalList: [],
      vipUnitPrice: 0,
      reviewCourseDate: [],
    };
  },
  components: {},
  created() {
    this.yearCourseTypeAllList = getYearCourseType();
    this.init();
  },
  computed: {
    studentAdvanceEnrollmentListInCourse: function () {
      let list = [];
      if (
        this.dataIn &&
        this.dataIn.courseData &&
        this.dataIn.courseData.studentAdvanceEnrollmentList
      ) {
        list = this.dataIn.courseData.studentAdvanceEnrollmentList.filter(
          (ae) =>
            (!ae.Used ||
              ae.Id == this.form.selectedStudentAdvanceEnrollmentId) &&
            this.studentAdvanceEnrollmentAdditionalList.indexOf(ae.Id) < 0
        );
      }
      return list;
    },
  },
  methods: {
    init() {
      this.isRetrieveCourseActivation = false;
      if (!!this.priceSettings) {
        this.bonusPointToMoney_Money =
          this.priceSettings.bonusPointToMoney_Money;
        this.bonusPointToMoney_BonusPoint =
          this.priceSettings.bonusPointToMoney_BonusPoint;
      }
      let currentWeekObj = this.dataIn.weekList.find((i) => i.IsCurrent);
      if (!!currentWeekObj) {
        this.currentWeek = currentWeekObj.Week;
      }

      if (!!this.dataIn) {
        this.loadStudentAdvanceEnrollmentAdditionalList();
        if (
          !!this.dataIn.modelData &&
          Object.keys(this.dataIn.modelData).length > 0
        ) {
          this.form = this.dataIn.modelData;
          if (typeof this.form.isAiCourseEnabled === "undefined") {
            this.$set(this.form, "isAiCourseEnabled", false);
          }
          if (typeof this.form.isEnsureACourse === "undefined") {
            this.$set(this.form, "isEnsureACourse", false);
          }
          this.preStudentAdvanceEnrollmentId =
            this.form.selectedStudentAdvanceEnrollmentId;
          if (
            !this.form.categoryId &&
            this.dataIn.courseCategoryList.length > 0
          ) {
            let categoryId = this.dataIn.courseCategoryList[0].Id;
            this.$set(this.form, "categoryId", categoryId);
          }
          if (
            this.dataIn.courseData.courseType == 2 ||
            this.dataIn.courseData.courseType == 4
          ) {
            this.hourStep = 2;
          }

          if (
            this.dataIn.courseData.courseType == 1 &&
            !!this.dataIn.courseData.studentAdvanceEnrollmentList
          ) {
            this.dataIn.courseData.studentAdvanceEnrollmentList.forEach(
              (element) => {
                if (
                  element.Id == this.form.selectedStudentAdvanceEnrollmentId
                ) {
                  element.Used = true;
                }
              }
            );
          }
          this.contractList = this.dataIn.contractList.filter(
            (i) => i.Enable || i.Id == this.dataIn.modelData.contractId
          );
          if (this.form.reviewCourseStart && this.form.reviewCourseEnd){
            this.reviewCourseDate = [];
            this.reviewCourseDate.push(new Date(this.form.reviewCourseStart));
            this.reviewCourseDate.push(new Date(this.form.reviewCourseEnd));
          }else{
            this.reviewCourseDate = [];
          }
        } else {
          this.form.isAdvanceEnrollmentPrice = false;
          this.form.isInternalPrice = false;
          this.form.isOriginalPrice = false;
          this.form.isFreeTrial = false;
          this.form.startWeek = this.currentWeek;
          this.form.isVideoFree = false;
          this.form.isAiCourseEnabled = false;
          this.form.isEnsureACourse = false;
          this.form.supplementVideoType = 0;
          this.form.categoryId = 0;
          this.form.categoryOptionId = 0;
          this.form.vipCoursePriceId = null;
          this.form.courseCount = 1;
          this.form.courseMinutes = 0;
          this.form.contractId = "";
          this.form.hasContractAgreed = false;
          this.form.weChatGroupType = "";
          this.form.cashDecreased = 0;
          this.form.comment = "";
          this.form.selectedStudentAdvanceEnrollmentId = 0;
          this.preStudentAdvanceEnrollmentId = 0;
          this.form.yearCourseType = 0;
          this.form.courseActivationIdList = [];
          this.form.freeTrialCourseActivationId = "";
          this.contractList = this.dataIn.contractList;
          this.form.courseAlias = "";
          this.form.reviewCourseStart = null;
          this.form.reviewCourseEnd = null;
          this.reviewCourseDate = [];
        }

        if (this.dataIn.courseData.isYearCourse) {
          if (!this.dataIn.courseData.yearCourseTypeWithWeek) {
            getYearCourseTypeWithWeek(this.dataIn.courseData.courseId).then(
              (result) => {
                if (result && result.success) {
                  this.yearCourseTypeWithWeek = result.data;
                  this.loadYearCourseTypeList();
                }
              }
            );
          } else {
            this.yearCourseTypeWithWeek =
              this.dataIn.courseData.yearCourseTypeWithWeek;
            this.loadYearCourseTypeList();
          }
        }

        if (
          !!this.dataIn.priceData &&
          Object.keys(this.dataIn.priceData).length > 0
        ) {
          this.financialModel = this.dataIn.priceData;
        } else {
          this.financialModel.price = 0;
          this.financialModel.weekPrice = 0;
          this.financialModel.discountPrice = 0;
          this.financialModel.subtotal = 0;
          this.financialModel.supplementVideoPrice = 0;
          this.financialModel.bonusPointCost = 0;
          this.financialModel.bonusPointAmount = 0;
          this.financialModel.cashDecreasedAmount = 0;
          this.financialModel.oldBonusPointCost = 0;
          this.financialModel.couponCode = "";
          this.financialModel.couponDiscountDollar = 0;
          this.financialModel.couponDiscountPrice = 0;
        }
      }

      this.loadCategoryOptions();
      this.studentAdvanceEnrollmentList =
        this.dataIn.studentAdvanceEnrollmentList;
      this.loadCourseAssureScore();
    },
    loadCourseAssureScore() {
      if (this.dataIn.courseData.courseType == 1) {
        getCourseAssureScore(
          this.dataIn.courseData.courseId,
          this.form.yearCourseType
        ).then((result) => {
          if (result && result.success) {
            this.courseAssureScore = result.data;
          }
        });
      }
    },
    loadYearCourseTypeList() {
      this.yearCourseTypeList = [];
      if (
        this.dataIn.courseData.isYearCourse &&
        !!this.yearCourseTypeWithWeek
      ) {
        let keys = Object.keys(this.yearCourseTypeWithWeek);
        this.yearCourseTypeAllList.forEach((i) => {
          if (keys.indexOf(i.Value.toString()) >= 0) {
            this.yearCourseTypeList.push(i);
          }
        });
        if (this.yearCourseTypeList.length > 0 && !this.form.yearCourseType) {
          this.form.yearCourseType = this.yearCourseTypeList[0].Value;
        }
        this.loadYearCourseWeekList();
      }
    },
    loadYearCourseWeekList(isResetWeek) {
      if (this.dataIn.courseData.isYearCourse) {
        if (!!this.yearCourseTypeWithWeek[this.form.yearCourseType]) {
          this.yearCourseWeekList =
            this.yearCourseTypeWithWeek[this.form.yearCourseType];
          if (isResetWeek) {
            let currentWeekObj = this.yearCourseWeekList.find(
              (i) => i.IsCurrent
            );
            if (!!currentWeekObj) {
              this.form.startWeek = currentWeekObj.Week;
            } else {
              this.form.startWeek = this.yearCourseWeekList[0].Week;
            }
          }
        } else {
          this.yearCourseWeekList = [];
        }
      } else {
        this.yearCourseWeekList = [];
      }
    },
    courseAliasQuerySearch(queryString, cb) {
      let aliasList = Object.assign([], this.vipCourseAliasList);
      if (!!queryString)
        aliasList = aliasList.filter((value) =>
          value.toUpperCase().contains(queryString.toUpperCase())
        );
      let qsData = aliasList.map((value) => ({ value }));
      cb(qsData);
    },
    onYearCourseTypeChange() {
      this.loadCourseAssureScore();
      this.loadYearCourseWeekList(true);
      this.triggerCalculate();
    },
    onContractChange() {
      this.$emit("contractChange", this.form.contractId);
    },
    onCategoryChange() {
      this.loadCategoryOptions();
      this.triggerCalculate();
    },
    onVipCoursePriceChange() {
      this.triggerCalculate();
      this.setVipCourseUnitPrice();
    },
    onCategoryOptionChange() {
      this.checkForHourPirce();
      this.triggerCalculate();
    },
    onCourseCountChange() {
      this.triggerCalculate();
    },
    onCourseMinutesChange(){
      this.triggerCalculate();
    },
    onStartWeekChange() {
      this.triggerCalculate();
    },
    onSupplementVideoTypeChange() {
      switch (this.form.supplementVideoType) {
        case 0: {
          //不补看视频
          this.form.supplementVideoCount = 0;
          break;
        }
        case 1: {
          //补看一节课视频
          this.form.supplementVideoCount = 1;
          break;
        }
        case 2: {
          //补看所有缺课视频
          //this.form.supplementVideoCount = this.form.startWeek - 1;
          this.form.supplementVideoCount = 0;

          break;
        }
      }

      this.triggerCalculate();
    },
    loadCategoryOptions() {
      if (
        this.dataIn.courseData.courseType == 2 ||
        this.dataIn.courseData.courseType == 3 ||
        this.dataIn.courseData.courseType == 4
      ) {
        return;
      }
      let categoryId = this.form.categoryId;
      let category = this.dataIn.courseCategoryList.filter(
        (i) => i.Id == categoryId
      );
      if (category.length > 0) {
        if (categoryId === this.GLOBAL.enumNormalCourseCategory.NormalClass) {
          this.hasFreeTrial = true;
        
          if (this.form.isFreeTrial) {
            this.checkForFreeTrial();
            this.loadAllCourseActivations();
          } else {
            this.isOnlineCourse = false;
            this.isNormalClass = true;
          }

          this.isHourPrice = false;
          this.isReviewCourse = false;
          this.isVip = false;
          this.vipUnitPrice = 0;
          this.form.categoryOptionId = null;
          this.form.vipCoursePriceId = null;
        } else if (
          categoryId === this.GLOBAL.enumNormalCourseCategory.OnlineCourse ||
          categoryId === this.GLOBAL.enumNormalCourseCategory.OMO ||
          categoryId === this.GLOBAL.enumNormalCourseCategory.OfflineCourse
        ) {
          this.hasFreeTrial = true;

          if (this.form.isFreeTrial) {
            this.checkForFreeTrial();
            this.loadAllCourseActivations();
          } else {
            this.isOnlineCourse = true;
            this.isNormalClass = true;
            if (this.form.supplementVideoType == 5) {
              this.isOnlineCourseVideoFree = true;
            } else {
              this.isOnlineCourseVideoFree = false;
            }
          }

          this.isHourPrice = false;
          this.isReviewCourse = false;
          this.isVip = false;
          this.vipUnitPrice = 0;
          this.form.categoryOptionId = null;
          this.form.vipCoursePriceId = null;
        } else {
          this.hasFreeTrial = false;
          this.form.isFreeTrial = false;

          this.form.isInternalPrice = false;
          this.form.isOriginalPrice = false;
          this.form.isVideoFree = false;
          this.form.isAiCourseEnabled = false;
          this.form.isEnsureACourse = false;
          this.form.isAdvanceEnrollmentPrice = false;

          this.categoryOptionList = category[0].CourseCategoryOptionsList;
          let isExist = false;
          let option = this.categoryOptionList.filter(
            (i) => i.Id == this.form.categoryOptionId
          );
          if (option.length > 0) {
            isExist = true;
          }

          if (categoryId === this.GLOBAL.enumNormalCourseCategory.Vip) {
            this.isVip = true;
            if (!this.form.vipCoursePriceId) {
              this.form.vipCoursePriceId = this.dataIn.vipCoursePrices[0].Id;
            }
            this.setVipCourseUnitPrice();
            this.form.categoryOptionId = null;
          } else {
            this.isVip = false;
            this.vipUnitPrice = 0;
            if (!isExist) {
              this.form.categoryOptionId = this.categoryOptionList[0].Id;
            }
            this.form.vipCoursePriceId = null;
          }
          this.isOnlineCourse = false;
          this.isNormalClass = false;
          this.checkForHourPirce();
          if (categoryId === this.GLOBAL.enumNormalCourseCategory.MidtermReview 
            || categoryId === this.GLOBAL.enumNormalCourseCategory.FinalReview
            || categoryId === this.GLOBAL.enumNormalCourseCategory.FinalPublic) {

            this.isReviewCourse = true;
            this.loadAllCourseActivations();
            // if (!this.isRetrieveReviewCourseActivation) {
            //   this.isLoadingReviewCourseActivationList = true;
            //   getReviewCourseActivations(this.dataIn.courseData.courseId)
            //     .then((result) => {
            //       if (result && result.success) {
            //         this.reviewCourseActivationListAll = result.data;
            //         this.isRetrieveReviewCourseActivation = true;
            //         this.loadReviewCourseActivationList();
            //       }
            //       this.isLoadingReviewCourseActivationList = false;
            //     })
            //     .catch(() => {
            //       this.isLoadingReviewCourseActivationList = false;
            //     });
            // } else {
            //   this.loadReviewCourseActivationList();
            // }
          }else{
            this.isReviewCourse = false;
          }
        }
      } else {
        this.isHourPrice = false;
      }
    },
    loadAllCourseActivations(){
      if (this.isRetrieveCourseActivation){
        this.loadCourseActivationList();
      }else{
        this.isLoadingCourseActivationList = true;
        getCourseActivations(this.dataIn.courseData.courseId)
          .then((result) => {
            if (result && result.success) {
              this.courseActivationListAll = result.data;
              this.isRetrieveCourseActivation = true;
              this.loadCourseActivationList();
            }
            this.isLoadingCourseActivationList = false;
          })
          .catch(() => {
            this.isLoadingCourseActivationList = false;
          });
      }
    },
    loadCourseActivationList() {
      if (!this.isReviewCourse){
        this.freeTrialCourseActivationList = JSON.parse(JSON.stringify(this.courseActivationListAll));
        
        if (this.freeTrialCourseActivationList.length > 0){
          let isExisting = false;
          if (this.form.freeTrialCourseActivationId){
            let item = this.freeTrialCourseActivationList.find(i => i.Id === this.form.freeTrialCourseActivationId);
            if (item){
              isExisting = true;
            }
          }
          if (!isExisting){
            this.$set(this.form, "freeTrialCourseActivationId", this.freeTrialCourseActivationList[0].Id);
          }
          
        }else{
          this.form.freeTrialCourseActivationId = "";
        }
        
      }else{
        let list = this.courseActivationListAll.filter(
          (i) => i.CourseCategory == this.form.categoryId
        );
        this.reviewCourseActivationList = JSON.parse(JSON.stringify(list));
        this.form.courseActivationIdList = [];
      }
    },
    checkForFreeTrial(){
      if (this.form.isFreeTrial){
        this.isOnlineCourse = false;
        this.isNormalClass = false;
        this.isOnlineCourseVideoFree = false;
      }
    },
    checkForHourPirce() {
      let isHour = false;
      let option = this.categoryOptionList.filter(
        (i) => i.Id == this.form.categoryOptionId
      );
      if (option.length > 0) {
        if (option[0].IsHourPrice) {
          isHour = true;
        }
      }

      this.isHourPrice = isHour;
    },
    getCourseCategoryText() {
      let result = this.dataIn.courseCategoryList.filter(
        (i) => i.Id == this.form.categoryId
      );
      if (result.length > 0) {
        return result[0].Label;
      }
      return "";
    },
    getVipCoursePriceDescription() {
      let desc = "";
      let result = this.dataIn.vipCoursePrices.find(
        (i) => i.Id == this.form.vipCoursePriceId
      );
      if (result) {
        desc = result.Description;
      }
      return desc;
    },
    setVipCourseUnitPrice() {
      let price = 0;
      let result = this.dataIn.vipCoursePrices.find(
        (i) => i.Id == this.form.vipCoursePriceId
      );
      if (result) {
        price = result.Price;
      }
      this.vipUnitPrice = price;
    },
    getCourseCategoryOptionText() {
      let text = "";
      let result = this.categoryOptionList.filter(
        (i) => i.Id == this.form.categoryOptionId
      );
      if (result.length > 0) {
        text = result[0].Label;
      }
      return text;
    },
    getPriceTypeText() {
      let text = "";
      if (this.form.isAdvanceEnrollmentPrice) {
        text = "占位价";
      } else if (this.form.isInternalPrice) {
        text = "内部价";
      } else if (this.form.isOriginalPrice) {
        text = "原价";
      } else {
        text = "正常价格";
      }
      return text;
    },
    getWeekText() {
      if (!!this.dataIn) {
        let item = null;
        if (this.dataIn.courseData.isYearCourse) {
          item = this.yearCourseWeekList.find(
            (i) => i.Week == this.form.startWeek
          );
        } else {
          item = this.dataIn.weekList.find(
            (i) => i.Week == this.form.startWeek
          );
        }
        if (item) {
          return item.Label;
        }
      }
      return "";
    },
    getSupplementVideoTypeText() {
      if (!!this.dataIn) {
        let item = this.dataIn.supplementVideoTypeList.filter(
          (i) => i.Key == this.form.supplementVideoType
        );
        if (item.length > 0) {
          return item[0].Value;
        }
      }
      return "";
    },
    getIsAiCourseEnabledText() {
      return this.form.isAiCourseEnabled ? "是" : "否";
    },
    getIsEnsureACourseText() {
      return this.form.isEnsureACourse ? "是" : "否";
    },
    getIsVideoFreeText() {
      if (this.form.isVideoFree) {
        return "视频课";
      }
      return "";
    },
    getContractText() {
      if (!!this.dataIn) {
        let item = this.dataIn.contractList.filter(
          (i) => i.Id == this.form.contractId
        );
        if (item.length > 0) {
          return item[0].Description;
        } else {
          return "未签约";
        }
      }
      return "";
    },
    getYearCourseTypeText() {
      let item = this.yearCourseTypeAllList.find(
        (i) => i.Value == this.form.yearCourseType
      );
      if (!!item) {
        return item.Text;
      }
      return "";
    },

    // getWeChatGroupTypeText() {
    //   if (!!this.dataIn) {
    //     let item = this.dataIn.weChatGroupTypeList.filter(
    //       i => i.Key == this.form.weChatGroupType
    //     );
    //     if (item.length > 0) {
    //       return item[0].Value;
    //     }
    //   }
    //   return "";
    // },
    onIsAdvanceEnrollmentPriceChange() {
      this.handleAdvanceEnrollmentPriceChange(true);
    },
    handleAdvanceEnrollmentPriceChange(isCalculated) {
      if (this.form.isAdvanceEnrollmentPrice) {
        this.form.isInternalPrice = false;
        this.form.isOriginalPrice = false;
      } else if (
        !this.form.isAdvanceEnrollmentPrice &&
        !!this.dataIn.courseData.studentAdvanceEnrollmentList
      ) {
        this.dataIn.courseData.studentAdvanceEnrollmentList.forEach(
          (element) => {
            if (element.Id == this.form.selectedStudentAdvanceEnrollmentId) {
              element.Used = false;
            }
          }
        );
        this.form.selectedStudentAdvanceEnrollmentId = 0;
        this.preStudentAdvanceEnrollmentId = 0;
      }

      if (isCalculated) {
        this.triggerCalculate();
      }
    },
    onSelectedStudentAdvanceEnrollmentIdChange() {
      this.handleAdvanceEnrollmentIdChange(true);
    },
    handleAdvanceEnrollmentIdChange(isCalculated) {
      this.dataIn.courseData.studentAdvanceEnrollmentList.forEach((element) => {
        if (element.Id == this.form.selectedStudentAdvanceEnrollmentId) {
          element.Used = true;
        }
        if (element.Id == this.preStudentAdvanceEnrollmentId) {
          element.Used = false;
        }
      });

      this.preStudentAdvanceEnrollmentId =
        this.form.selectedStudentAdvanceEnrollmentId;

      if (this.form.selectedStudentAdvanceEnrollmentId != 0 && isCalculated) {
        this.triggerCalculate();
      }
    },
    //课程连报优惠自动选中占位
    selectAdvanceEnrollmentForDiscount(isSelected, studentAdvanceEnrollmentId) {
      this.isAdvanceEnrollmentDisabled = isSelected;

      if (isSelected) {
        if (this.form.isAdvanceEnrollmentPrice != isSelected) {
          this.form.isAdvanceEnrollmentPrice = isSelected;
          this.handleAdvanceEnrollmentPriceChange(false);
        }

        if (
          this.form.selectedStudentAdvanceEnrollmentId !=
          studentAdvanceEnrollmentId
        ) {
          this.form.selectedStudentAdvanceEnrollmentId =
            studentAdvanceEnrollmentId;
          this.handleAdvanceEnrollmentIdChange(false);
        }
      }
    },
    onModelChange() {
      this.triggerCalculate();
    },
    onIsInternalPriceChange() {
      if (this.form.isInternalPrice) {
        this.form.isAdvanceEnrollmentPrice = false;
        this.form.isOriginalPrice = false;
      }
      this.triggerCalculate();
    },
    onIsOriginalPriceChange() {
      if (this.form.isOriginalPrice) {
        this.form.isAdvanceEnrollmentPrice = false;
        this.form.isInternalPrice = false;
      }
      this.triggerCalculate();
    },
    onIsFreeTrialChange() {
      this.loadCategoryOptions();
      this.triggerCalculate();
    },
    onBonusPointCostChange() {
      let bonusPointCostValue = Math.abs(
        parseInt(this.financialModel.bonusPointCost)
      );
      if (isNaN(bonusPointCostValue)) bonusPointCostValue = 0;
      let currentBonusPoint =
        this.financialModel.oldBonusPointCost + this.availableBonusPoint;
      if (bonusPointCostValue > currentBonusPoint)
        bonusPointCostValue = currentBonusPoint;

      let bonusPointAmount =
        this.calculateBonusPointAmount(bonusPointCostValue);
      if (
        bonusPointAmount >
        this.financialModel.discountPrice -
          this.financialModel.cashDecreasedAmount
      ) {
        bonusPointAmount =
          this.financialModel.discountPrice -
          this.financialModel.cashDecreasedAmount;
        if (bonusPointAmount < 0) bonusPointAmount = 0;
        bonusPointCostValue = this.calculateBonusPointCost(bonusPointAmount);
      }

      this.financialModel.bonusPointCost = bonusPointCostValue;
      this.financialModel.bonusPointAmount = bonusPointAmount;

      this.financialModel.oldBonusPointCost = bonusPointCostValue;

      this.triggerCalculate();
    },
    onCashDecreasedAmountChange() {
      let cashDecreasedAmountValue = Math.abs(
        convertToFloat(this.financialModel.cashDecreasedAmount)
      );
      if (isNaN(cashDecreasedAmountValue)) cashDecreasedAmountValue = 0;

      if (
        cashDecreasedAmountValue >
        this.financialModel.discountPrice - this.financialModel.bonusPointAmount
      ) {
        cashDecreasedAmountValue =
          this.financialModel.discountPrice -
          this.financialModel.bonusPointAmount;
        if (cashDecreasedAmountValue < 0) cashDecreasedAmountValue = 0;
      }

      this.financialModel.cashDecreasedAmount = cashDecreasedAmountValue;

      this.triggerCalculate();
    },
    calculateBonusPointAmount(bonusPointCost) {
      let retVal = 0;

      if (this.bonusPointToMoney_BonusPoint > 0) {
        retVal =
          (parseInt(bonusPointCost) * this.bonusPointToMoney_Money) /
          this.bonusPointToMoney_BonusPoint;
      }

      return retVal;
    },
    calculateBonusPointCost(bonusPointAmount) {
      let retVal = 0;

      if (this.bonusPointToMoney_Money > 0) {
        retVal =
          (parseInt(bonusPointAmount) * this.bonusPointToMoney_BonusPoint) /
          this.bonusPointToMoney_Money;
      }

      return retVal;
    },
    triggerCalculate() {
      this.$emit("calculate");
    },
    onCouponCodeClick() {
      if (!this.financialModel.couponCode) {
        this.$message.error("优惠码不能为空");
        return;
      }
      validateCoupon(this.studentId, this.financialModel.couponCode, 0).then(
        (result) => {
          if (result && result.success) {
            this.financialModel.couponDiscountDollar =
              result.data.DiscountDollar;
            this.triggerCalculate();
          } else {
            this.$message.error(result.message);
          }
        }
      );
    },
    onCouponRevertClick() {
      this.financialModel.couponCode = "";
      this.financialModel.couponDiscountDollar = 0;
      this.triggerCalculate();
    },
    onReviewCourseActivationChange() {},
    onFreeTrialCourseActivationChange() {
    },
    getCourseActivationText(courseActivationId) {
      let item = this.courseActivationListAll.find(
        (i) => i.Id == courseActivationId
      );
      if (!!item) {
        return item.Name;
      }
      return "";
    },
    onOnlineCourseVideoFreeChange() {
      if (this.isOnlineCourseVideoFree) {
        this.form.supplementVideoType = 5;
      } else {
        this.form.supplementVideoType = 0;
      }
      this.triggerCalculate();
    },
    loadStudentAdvanceEnrollmentAdditionalList() {
      if (
        this.dataIn &&
        this.dataIn.courseData &&
        this.dataIn.courseData.studentAdvanceEnrollmentAdditional
      ) {
        let list =
          this.dataIn.courseData.studentAdvanceEnrollmentAdditional.split(",");
        this.studentAdvanceEnrollmentAdditionalList = list.map((i) =>
          parseInt(i)
        );
      } else {
        this.studentAdvanceEnrollmentAdditionalList = [];
      }
    },
    onHasContractAgreedChange() {
      let workflowCourseId = this.form.id;
      agreeEFWCourseContracts([workflowCourseId]).then((result) => {
        if (!!result && result.success) {
          this.$emit("contractAgreed", this.form.id);
        }
      });
    },
    downloadContractFile(contractId) {
      let contractFiles = this.__findContractFiles(contractId);
      if (contractFiles.length === 0) {
        this.$message.error("未能正确获取到文件数据。");
        return;
      }

      this.downloadLoading = true;
      getBlobFileUrlById(contractFiles[0].FileStorageId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            downloadFileToBlob(Url, 0)
              .then((res) => {
                if (!!res && !!res.data)
                  downloadFile({ data: res.data, filename: FileName });
                else this.$message.error("未能正确获取到文件数据。");

                this.downloadLoading = false;
              })
              .catch(() => {
                this.downloadLoading = false;
              });
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }

            this.downloadLoading = false;
          }
        })
        .catch(() => {
          this.downloadLoading = false;
        });
    },
    __findContractFiles(contractId) {
      let contractList = Object.values(this.allContractList).find((items) =>
        items.some((item) => item.Id === contractId)
      );
      if (!contractList) return [];

      let contract = contractList.find((item) => item.Id === contractId);
      if (!contract) return [];

      return !!contract.Files ? contract.Files : [];
    },
    onReviewCourseDateChange(){
      let startDate = "";
      let endDate = "";
      if (!!this.reviewCourseDate && this.reviewCourseDate.length == 2) {
        startDate = formatDate(this.reviewCourseDate[0]);
        endDate = formatDate(this.reviewCourseDate[1]);
      }
      this.form.reviewCourseStart = startDate;
      this.form.reviewCourseEnd = endDate;
    }
  },
  watch: {
    dataIn: function () {
      this.init();
    },
    "dataIn.courseData.studentAdvanceEnrollmentAdditional": function () {
      this.loadStudentAdvanceEnrollmentAdditionalList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/courseEnrollmentDetail.vue